import React from 'react';
import { connect } from 'react-redux';
import DemandPlannerComponent from './DemandPlannerComponent';
import { scheduleCalendarOperations, } from '../ScheduleCalendar/duck';
import { availabilityOperations } from '../Availability/duck';
import { demandPlannerOperationsExtended } from './operations';
import { appOperations } from 'App/duck';


const mapStateToProps = ({
  locationReducer,
  appReducer,
  scheduleCalendarReducer,
  availabilityReducer,
  demandPlannerReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    rangeStart: scheduleCalendarReducer.dateRange.start,
    rangeEnd: scheduleCalendarReducer.dateRange.end,
    startStr: scheduleCalendarReducer.dateRange.startStr,
    usersLoading: scheduleCalendarReducer.allUsers.loading,
    allUsers: scheduleCalendarReducer.allUsers.users,
    plans: appReducer.plans.data,
    locationData: locationReducer.location_data,
    availabilities: availabilityReducer.availabilities,
    demandPlanner: demandPlannerReducer.demandPlanner,
    demandData: demandPlannerReducer.demandData,
    demandDataLoading: demandPlannerReducer.loading,
    demandDataError: demandPlannerReducer.error,
    roles: appReducer.roles.data,
    rolesLoading: appReducer.roles.loading,
  };
};

const mapDispatchToProps = (dispatch) => {

  const loadLocationRolesDispatch = (locationId) => {
    dispatch(appOperations.fetchLocationRolesOperation(locationId));
  }

  const loadDemandDataDispatch = (locationId) => {
    dispatch(demandPlannerOperationsExtended.fetchDemandData(locationId));
  }

  const notifyTeamDispatch = (locationId, message, users) => {
    dispatch(scheduleCalendarOperations.notifyTeamOperation(locationId, message, 'my_availability', users));
  };

  const loadAvailabilityDispatch = (locationId) => {
    dispatch(availabilityOperations.fetchAvailabilityOperation(locationId, 1, 10000));
  };

  const changeDateRangeSlice = (from, to) => {
    dispatch(scheduleCalendarOperations.changeDateRangeOperation(from, to));
  };

  return { 
    loadAvailabilityDispatch,
    changeDateRangeSlice,
    notifyTeamDispatch,
    loadLocationRolesDispatch,
    loadDemandDataDispatch,
  };
};

const DemandPlannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    locationId,
    rangeStart,
    rangeEnd,
    startStr,
    usersLoading,
    allUsers,
    plans,
    locationData,
    loadAvailabilityDispatch,
    changeDateRangeSlice,
    notifyTeamDispatch,
    availabilities,
    demandPlanner,
    loadLocationRolesDispatch,
    roles,
    rolesLoading,
    demandData,
    demandDataLoading,
    demandDataError,
    loadDemandDataDispatch,
    } = props;

  return <DemandPlannerComponent
    loadAvailabilityDispatch = {loadAvailabilityDispatch}
    changeDateRangeSlice = {changeDateRangeSlice}
    startStr = {startStr}
    rangeStart = {rangeStart}
    rangeEnd = {rangeEnd}
    loading = {usersLoading}
    allUsers = {allUsers}
    locationId = {locationId}
    availabilities = {availabilities}
    notifyTeamDispatch = {notifyTeamDispatch}
    locationData = {locationData}
    demandPlanner = {demandPlanner}
    loadLocationRolesDispatch = {loadLocationRolesDispatch}
    roles = {roles}
    rolesLoading = {rolesLoading}
    demandData = {demandData}
    demandDataLoading = {demandDataLoading}
    demandDataError = {demandDataError}
    loadDemandDataDispatch = {loadDemandDataDispatch}
   /> 
});

export default DemandPlannerContainer;